/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const home_testimonials_quote_4_text = () => `Understanding blockchain performance is difficult so the Chainspect service is very helpful. By monitoring the maximum performance blockchain technologies reach in production, Chainspect help demystify how layer-1 and layer-2's (among others) perform in reality.`
